import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rds-variable-information-decorators',
  templateUrl: './variable-information-decorators.component.html',
  styleUrls: ['./variable-information-decorators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RdsVariableInformationDecoratorsComponent {
  @Input() measure: boolean;
  @Input() required: boolean;
  @Input() weight: boolean;
}
